<template>
  <div class="body">
    <img :src="priceImgUrl" alt="" style="width: 100%; ">
    <div class="t-c">
      <div class="t-t">{{ title }}</div>
      <div class="t-f">
       
        <div class="t-v" :class="[inx === '3' ? 't-active' : '']" @click="inx = '3'">
          <div class="mark">5%人的选择</div>
          <div class="con1">充{{ threeData.buyPriceThree }}得</div>
          <div class="con2">{{ threeData.totalPriceThree }}<span class="yuan">元</span></div>
        </div>

        <div class="t-v" :class="[inx === '2' ? 't-active' : '']" @click="inx = '2'">
          <div class="mark">15%人的选择</div>
          <div class="con1">充{{ threeData.buyPriceTwo }}得</div>
          <div class="con2">{{ threeData.totalPriceTwo }}<span class="yuan">元</span></div>
        </div>
       
        <div class="t-v" :class="[inx === '1' ? 't-active' : '']" @click="inx = '1'">
          <div class="mark">80%人的选择</div>
          <div class="con1">充{{ threeData.buyPriceOne }}得</div>
          <div class="con2">{{ threeData.totalPriceOne }}<span class="yuan">元</span></div>
        </div>

      </div>
      
      <div class="tips_box" v-if="inx === '3'">
        <h3>充值{{ threeData.buyPriceThree }}元</h3>
        <p>开通需参加首充{{ threeData.buyPriceThree }}得{{ threeData.totalPriceThree }}活动，首充{{ threeData.buyPriceThree
        }}元，得{{ threeData.totalPriceThree }}元活动余额。
          订购套餐，实名认证后，即可畅享网络</p>
      </div>

      <div class="tips_box" v-if="inx === '2'">
        <h3>充值{{ threeData.buyPriceTwo }}元</h3>
        <p>开通需参加首充{{ threeData.buyPriceTwo }}得{{ threeData.totalPriceTwo }}活动，首充{{ threeData.buyPriceTwo
        }}元，得{{ threeData.totalPriceTwo }}元活动余额。
          订购套餐，实名认证后，即可畅享网络</p>
      </div>

      <div class="tips_box" v-if="inx === '1'">
        <h3>充值{{ threeData.buyPriceOne }}元</h3>
        <p>开通需参加首充{{ threeData.buyPriceOne }}得{{ threeData.totalPriceOne }}活动，首充{{ threeData.buyPriceOne
        }}元，得{{ threeData.totalPriceOne }}元活动余额。
          订购套餐，实名认证后，即可畅享网络</p>
      </div>
    </div>
    <div class="footer-btn">

      <div class="btn" v-if="inx === '3'" @click="toBuyPrice(threeData.buyPriceThree)">
        充{{ threeData.buyPriceThree }}得{{ threeData.totalPriceThree }}元</div>

      <div class="btn" v-if="inx === '2'" @click="toBuyPrice(threeData.buyPriceTwo)">
        充{{ threeData.buyPriceTwo }}得{{ threeData.totalPriceTwo }}元</div>

        <div class="btn" v-if="inx === '1'" @click="toBuyPrice(threeData.buyPriceOne)">
        充{{ threeData.buyPriceOne }}得{{ threeData.totalPriceOne }}元</div>
    </div>

    <!-- 修改密码框   -->
    <div class="van-overlay" style="z-index: 1999" v-show="showPasswordPanel"></div>
    <div class=" 
        van-popup van-popup--round van-popup--center
        changePasswordPanel-cardSetUp
      " style="z-index: 2000; min-height: 25%; min-width: 80%" v-show="showPasswordPanel"
      :style="{ top: passwordPanelTop + '%' }">
      <van-icon name="cross" class="icon-cross" @click="cancelChangePassword()" />

      <!-- 密码输入框 -->
      <p>设置开户支付密码：</p>
      <van-password-input :value="password" :focused="passwordKeyboard" @focus="passwordOnfocus()" />

      <!-- 再次确认密码输入框 -->
      <p>再次确认开户密码：</p>
      <van-password-input :value="confirmPassword" :focused="confirmPasswordKeyboard" @focus="confirmPasswordOnfocus()" />
      <div class="confirmChangePassword">
        <van-button class="confirmChangePasswordBtn" plain hairline type="info" @click="sureToRecharge()">确 定
        </van-button>
      </div>
    </div>

    <!-- 数字键盘 -->
    <van-number-keyboard :z-index="2015" :show="passwordKeyboard" @input="passwordOnInput" @delete="passwordOnDelete"
      @blur="passwordKeyboard = false" />

    <van-number-keyboard :z-index="2015" :show="confirmPasswordKeyboard" @input="confirmPasswordOnInput"
      @delete="confirmPasswordOnDelete" @blur="confirmPasswordKeyboard = false" />

  </div>
</template>
<script>
import { Dialog, Toast } from "vant";
import areaListData from "@/utils/Area.js";
import { wxRequest } from "@/api/user.js";
export default {
  data() {
    return {
      gitPkgName: '', //赠送备注
      title: '', //标题
      city: '',
      is_WeChat: false,
      payUrl: '',

      cancelSize: 0,
      leshuaPay: localStorage.getItem("leshuaPay"),
      payCode: localStorage.getItem("payCode"),
      priceImgUrl: localStorage.getItem("PayImgUrl"),
      input: this.$store.state.recordLoginText,
      isDialogShow: false,
      //设置密码
      password: "",
      confirmPassword: "",
      alreadySetUp: false,
      showPasswordPanel: false,
      showPower: false,
      passwordKeyboard: false,
      confirmPasswordKeyboard: false,
      passwordPanelTop: 50,
      kefuUrl: localStorage.getItem("kefuUrl"),

      //当前余额套餐
      currentItem: 0,
      price: 0,
      giftBalance: 0,
      inx: '2',
      //自定义金额
      popup: false,
      salePrice: 0,

      //自定义键盘
      showKeyboard: false,
      definedPrice: "",

      type: "",
      indexActive: "",
      addressVisible: false,
      areaList: areaListData, //选择地址列表
      isWan: '1', // 是否展示回退弹窗   0不展示 1展示
      isIp: '1', //  是否展示手机号与归属地  0不展示 1展示
      ipAddr: '', // IP 默认归属地  北京市-北京市
      phoneNum: localStorage.getItem("virtualNo"), //手机号
      basePkgGroup: localStorage.getItem("basePkgGroup"),//获取套餐数据用的
      price: '',
      threeData: {
        buyPriceOne: '', // 充值金额
        totalPriceOne: '',//赠送金额

        buyPriceTwo: '',
        totalPriceTwo: '',

        buyPriceThree: '',
        totalPriceThree: '',

        imgUrl: '' //
      },
    };
  },
  created() {
    wxRequest("sim/select/price/infos", { iccid: localStorage.getItem("iccid"), basePkgGroup: this.basePkgGroup }, "post").then((res) => {
      if (res.data.code == 200) {
        this.title = res.data.data.title;
        this.gitPkgName = res.data.data.gitPkgName;
        var result = res.data.data;
        for (var key in this.threeData) {
          if (result[key]) {
            this.threeData[key] = result[key]
          }
        }
      }
    })


  },
  mounted() {

  },
  methods: {
    toBuyPrice(price) {
      this.price = price
      this.sureToRecharge(price);
    },
    cancelClose() {
      if (this.cancelSize >= 1) {
        this.isDialogShow = false;
      } else {
        this.cancelSize = 1;
        this.showPower = true
        history.pushState(null, null, document.URL)
      }

    },

    cancelTitle() {
      this.showPower = false;
    },
    toTitle() {
      this.showPower = false;
      //this.sureToRecharge(this.price)
    },
    /**选择地址 */
    showAddressVisible() {
      this.addressVisible = true;
    },

    cancelSelectAddress() {
      this.addressVisible = false;
      this.addressTmp = "";
      this.userInfo.pcaAddress = "";
    },

    selectAddress(values) {
      if (!values[0].code || values[0].code.length < 1) {
        Toast.fail("请选择地区");
        return;
      }

      if (!values[1].code || values[1].code.length < 1) {
        Toast.fail("请选择地区");
        return;
      }


      this.ipAddr = values[0].name + '-' + values[1].name;
      this.addressVisible = false;
    },
    /***   修改密码     ***/
    passwordOnfocus() {
      this.passwordKeyboard = true;
      this.confirmPasswordKeyboard = false;
      this.passwordPanelTop = 30;
    },
    passwordOnDelete() {
      this.password = this.password.slice(0, this.password.length - 1);
    },

    passwordOnInput(key) {
      this.password = (this.password + key).slice(0, 6);
    },

    confirmPasswordOnfocus() {
      this.passwordKeyboard = false;
      this.confirmPasswordKeyboard = true;
      this.passwordPanelTop = 30;
    },
    confirmPasswordOnDelete() {
      this.confirmPassword = this.confirmPassword.slice(0, this.confirmPassword.length - 1);
    },

    confirmPasswordOnInput(key) {
      this.confirmPassword = (this.confirmPassword + key).slice(0, 6);
    },

    cancelChangePassword() {
      this.password = "";
      this.confirmPassword = "";
      this.passwordPanelTop = 50;
      this.showPasswordPanel = false;
    },

    checkPassword() {
      if (this.password.length < 6) {
        Dialog.alert({ message: "请设置六位支付密码" });
        return false;
      }

      if (this.password != this.confirmPassword) {
        Dialog.alert({ message: "两次输入的新密码不一致" });
        return false;
      }
      return true;
    },

    /***   修改密码  end   ***/
    sumbit() {
      this.showPasswordPanel = true;
    },
    //流量套餐充值时唤起微信支付 
    onBridgeReady(param) {
      let _this = this;
      WeixinJSBridge.invoke("getBrandWCPayRequest", param, function (res) {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          if (_this.$store.state.isNewPage == 1 || localStorage.getItem('isNewPage') == 1) {
            _this.$router
              .push({
                path: "/userNew/bindPhone",
                query: {
                  iccid: _this.$store.state.iccid,
                },
              })
              .catch(() => { });
          } else {
            _this.$router
              .push({
                path: "/userNew/bindPhone",
                query: {
                  iccid: _this.$store.state.iccid,
                },
              })
              .catch(() => { });
          }

        }
      });
    },
    async sureToRecharge(price) {
      price = this.price;
      console.log('选择价格' + price)
      var params = {
        ali:localStorage.getItem("htmlType"),
        iccid: this.$store.state.iccid ? this.$store.state.iccid : localStorage.getItem("iccid"),
        amount: price * 100, //固定值
        giftBalance: 0, //固定值
        yucun: 1, //固定值
        payType: 20, // 固定微信支付
      };
      var postUrl = "order/user/create/priceOrder";
      await wxRequest("sim/pay/type", params, "post").then((res) => {
        if (res.data.code == 406) {
          postUrl = "order/user/create/priceOrderHf";
          params.payType = 60;
        } else if (res.data.code == 408) {
          postUrl = "order/ali/user/create/priceOrder";
          params.payType = 80;
        } else if (res.data.code == 409) {
          postUrl = "order/ali/user/create/priceOrder/mi";
          params.payType = 90;
        } else if (res.data.code == 410) {
          postUrl = "order/ali/user/create/priceOrder/dh";
          params.payType = 90;
        } else if (res.data.code == 491) {
          postUrl = "order/ali/user/create/priceOrder/hl";
          params.payType = 90;
        } else if (res.data.code == 492) {
          postUrl = "order/ali/user/create/priceOrder/yy";
          params.payType = 92;
        } else if (res.data.code == 493) {
          postUrl = "order/ali/user/create/priceOrder/long";
          params.payType = 90;
        } else if (res.data.code == 494) {
          postUrl = "order/ali/user/create/priceOrder/huo";
          params.payType = 93;
        }else if (res.data.code == 498) {
          postUrl = "order/ali/user/create/priceOrder/bf";
          params.payType = 98;
        }
      });
      await wxRequest(postUrl, params, "post").then((res) => {
        if (res.data.code == 200) {
          if (params.payType == 50) {
            //乐刷de
            window.location.href = res.data.data.jspay_url;
          } else if (params.payType == 92 || params.payType == 93|| params.payType == 98) {
            //云游
            window.location.href = res.data.data;
          } else if (params.payType == 20) {
            //微信第三方
            var param = res.data.data.param;
            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener(
                  "WeixinJSBridgeReady",
                  this.onBridgeReady,
                  false
                );
              } else if (document.attachEvent) {
                document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
                document.attachEvent(
                  "onWeixinJSBridgeReady",
                  this.onBridgeReady
                );
              }
            } else {
              this.onBridgeReady(param);
            }
          } else if (params.payType == 90) {
            //微信第三方
            var param = res.data.data;
            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener(
                  "WeixinJSBridgeReady",
                  this.onBridgeReady,
                  false
                );
              } else if (document.attachEvent) {
                document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
                document.attachEvent(
                  "onWeixinJSBridgeReady",
                  this.onBridgeReady
                );
              }
            } else {
              this.onBridgeReady(param);
            }
          } else if (params.payType == 60) {
            //汇付天下
            let datas = JSON.parse(res.data.data);
            if (datas.status === "succeeded") {
              let payment = datas;
              AdaPay.doPay(payment, (res) => {
                Dialog.alert({ title: "提示", message: res.result_message });
              });
            }
          } else if (params.payType == 80) {
            window.location.href = res.data.data;
          }
        } else {
          Dialog.alert({ message: res.data.message });
        }
      });

    },
  },
};
</script>
<style lang="less" scoped>
.body {
  /* //background: url('../../assets/dzp/le20.jpg')no-repeat center; */
  background-repeat: no-repeat !important;
  background-position: center !important;
  background-size: 100% 100% !important;
  width: 100%;
  height: 100vh;
  position: relative;

  .footer-btn {
    position: fixed;
    bottom: 0px;
    left: 0px;
    right: 0px;
    margin: auto;

    .btn {
      width: 325px;
      height: 48px;
      background: linear-gradient(to right, rgb(255, 96, 52), rgb(238, 10, 36));
      /* background-size: 100% 100%; */
      margin: 10px auto;
      font-size: 18px;
      font-weight: 700;
      text-align: center;
      line-height: 48px;
      color: #fff;
      border-radius: 30px;
      animation: free_download 1s linear infinite alternate;
    }
  }

  .t-c {
    border: 5px solid #50b9fd;
    border-radius: 10px;
    margin: 20px 30px 10px;
    padding: 30px 6px 20px;
    position: relative;

    .t-t {
      position: absolute;
      left: 50%;
      top: -20px;
      margin-left: -100px;
      width: 200px;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      color: #fff;
      background-color: #50b9fd;
      border-radius: 10px;
      text-align: center;
      font-weight: bolder;
      letter-spacing: 2px;
    }

    .t-f {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .t-v {
        width: 31%;
        height: 112px;
        background: url('~@/assets/dzp/1.png')no-repeat center;
        background-size: 100% 100%;
        font-size: 12px;
        font-weight: 700;
        padding: 20px 10px;
        box-sizing: border-box;
        position: relative;

        .mark {
          position: absolute;
          left: 0;
          top: 0;
          background-color: #d2d2d2;
          color: #fff;
          font-size: 12px;
          border-top-left-radius: 10px;
          border-bottom-right-radius: 10px;
          padding: 1px 8px;
        }

        .con2 {
          font-size: 26px;
          position: relative;
        }
      }

      .t-active {
        background: url('~@/assets/dzp/2.png')no-repeat center;
        background-size: 100% 100%;

        .mark {
          background-color: #50b9fd;
          color: #000;
        }
      }
    }

    .tips_box {
      background-color: #d1f0ff;
      padding: 6px 10px;
      border-radius: 15px;
      font-size: 12px;
      margin-top: 5px;
      width: calc(100% - 35px);
      margin-right: 15px;
      padding-top: 12px;

      h3 {
        font-size: 16px;
        margin-bottom: 5px;
        font-weight: bolder;
      }

      p {
        line-height: 20px;
      }
    }
  }

  .v-dialog {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;

    .v-dialog-bg {
      position: fixed;
      background: rgba(0, 0, 0, 0.7);
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      width: 100%;
      height: 100%;
    }

    .v-dialog-close {
      width: 22px;
      height: 22px;
      // margin:0 auto;
      // margin-top:20px;
      position: fixed;
      top: 0;
      bottom: -300px;
      left: 0;
      right: 0;
      margin: auto;

      img {
        height: 100%;
        cursor: pointer;
      }
    }

    .v-dialog-content {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      width: 100%;
      height: 100%;

      /* background: url("../../assets/user/3231.png") no-repeat center;
      background-size: 80% 50%; */
      .eixfr {
        position: relative;
        width: 90%;
        height: 360px;
        top: 20%;
        left: 5%;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .number {
        position: absolute;
        font-size: 18px;
        font-weight: 600;
        background: linear-gradient(to bottom, #D40017, #FF9115);
        /* 从左到右渐变 */
        -webkit-background-clip: text;
        /* Safari/Chrome */
        -webkit-text-fill-color: transparent;
        /* Safari/Chrome */
        color: transparent;
        /* Firefox/Opera */
        /* left: 24.5%; */
        top: 52%;
        font-family: DIN-Black;
        width: 97%;
        text-align: center;
      }

      .input {
        text-align: center;
        font-size: 10px;
        color: #7B3030;
        top: 64%;
        left: 39%;
        position: absolute;
      }

      .sumbit_btn {
        height: 46px;
        position: absolute;
        bottom: 14px;
        display: flex;
        left: -10px;
        margin: auto;
        right: 0;
        background: url("../../assets/dzp/321.png") no-repeat center;
        background-size: 100% 100%;
        animation: free_download 1s linear infinite alternate;
        width: 68%;
      }
    }
  }
}

@keyframes free_download {
  0% {
    transform: scale(.9);
  }

  100% {
    transform: scale(1);
  }
}

.i-a {
  display: flex;
  justify-content: space-between;
  margin: 0 30px;
  align-items: center;
}

.iphone {
  /* margin-bottom: 6px; */
  margin-left: 10px;
  font-size: 15px;
  font-weight: bold;

  span {
    color: #333;
  }

  .djsa {
    color: #c30d23;
  }
}


.changePasswordPanel-cardSetUp {
  padding: 10px;

  .icon-cross {
    position: absolute;
    right: 10px;
    font-size: 16px;
  }

  p {
    margin: 10px 16px 0 16px;
    line-height: 30px;
  }

  .confirmChangePassword {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;

    .confirmChangePasswordBtn {
      width: 80px;
      margin: 0 15px;
    }
  }
}

.shareit {
  -webkit-user-select: none;
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  text-align: center;
  top: 0;
  left: 0;
  z-index: 999;
}

.shareit img {
  max-width: 100%;
}

.arrow {
  width: 100px;
  height: 150px;
  position: absolute;
  right: 5%;
  top: 1%;
}

.follow {
  margin-right: 6px;
  margin-left: 30px;
  width: 90%;
  // height: 100rpx;
  line-height: 30px;
  // text-align: left;
  text-decoration: none;
  font-size: 18px;
  color: white;
  float: left;
  margin-top: 180px;
}

.wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 38.2vh;
  left: 50%;
  margin-top: -50%;
  margin-left: -50%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .wrapper-img {
    width: 90%;
    height: 45%;
  }

  .close {
    width: 24px;
    position: relative;
    padding: 0;
    cursor: pointer;
    background: 0 0;
    border: 0;
    font-size: .53333rem;
    font-weight: 700;
    line-height: 1;
    margin-top: 60px;
    color: #000;
    text-shadow: 0 0.02667rem 0 #fff;
  }
}
</style>